export default class Service {
  service
  confirmation
  percentage
  status = 1
  type
  location
  destination
  destinationLat
  destinationLong
  van
  vanLat
  vanLong
  heading
  driver = ''
  grade
  time = ''
  arrivalTime = '-'
  serviceDate
  balance = '0'
  w3cDate = ''
  pax
  serviceDistance
  preasignacion = 0
  editBase
  editParams
  confirmedFlight = 0
  horaRecibido
  horaAbordado
  horaEnterado
  horaIniciado
  horaTerminado
  rate
  suburban

  constructor(
    service,
    confirmation,
    location,
    destination,
    destinationLat,
    destinationLong,
    van,
    vanLat,
    vanLong,
    heading,
    driver,
    type,
    grade,
    serviceDate,
    status = 1,
    editBase,
    editParams,
    rate
  ) {
    this.service = service
    this.confirmation = confirmation
    this.location = location
    this.destination = destination
    this.destinationLat = destinationLat
    this.destinationLong = destinationLong
    this.van = van
    this.vanLat = vanLat
    this.vanLong = vanLong
    this.heading = heading
    this.driver = driver
    this.type = type
    this.grade = grade
    this.serviceDate = serviceDate
    this.status = status
    this.editBase = editBase
    this.editParams = editParams
    this.rate = rate
  }

  get getType() {
    if (this.type != null) {
      switch (this.type) {
        case 'LL':
          return 'Arrival'
        case 'SA':
          return 'Departure'
        case 'TF':
          return 'Hotel to Hotel'
        case 'EX':
          return 'Tour'
        default:
          return 'Loading...'
      }
    }

    return 'Loading...'
  }

  get getTime() {
    if (this.time != null) {
      const splittedTime = this.time.split(':')
      return splittedTime[0] + ':' + splittedTime[1]
    } else {
      return this.time
    }
  }

  getServiceStatus() {
    switch (this.status) {
      case '2':
        return 'Confirmed'
      case '3':
        return 'Completed'
      case '4':
        return 'Canceled'
      case '6':
        return 'NO SHOW'
      default:
        return 'Pending'
    }
  }
}
